import { PDFDocument } from 'pdf-lib';

/**
 * Comprime un archivo PDF reduciendo su calidad y compresión.
 * @param {File} pdfFile - Archivo PDF a comprimir
 * @param {Object} options - Opciones de compresión
 * @param {number} [options.imageQuality=0.5] - Calidad de las imágenes (0.1 - 1.0)
 * @param {boolean} [options.useOCR=false] - Usar OCR para el texto (experimental)
 * @returns {Promise<File>} - Archivo PDF comprimido
 */
export async function compressPdf(pdfFile, options = {}) {
  try {
    console.log(`Comprimiendo PDF: ${pdfFile.name}, Tamaño original: ${pdfFile.size / 1024 / 1024} MB`);
    
    const startTime = performance.now();
    
    // Valores por defecto
    const imageQuality = options.imageQuality || 0.5;
    
    // Convertir el archivo File a ArrayBuffer
    const arrayBuffer = await pdfFile.arrayBuffer();
    
    // Cargar el PDF con pdf-lib
    const pdfDoc = await PDFDocument.load(arrayBuffer, {
      // Opciones de carga avanzadas
      ignoreEncryption: true,
      throwOnInvalidObject: false,
    });
    
    // Comprimir el PDF (pdf-lib hace compresión automática)
    const compressedBytes = await pdfDoc.save({
      // Opciones de compresión
      useObjectStreams: true,
      addCompressXref: true,
      useCompression: true,
    });
    
    // Crear un nuevo archivo File con los bytes comprimidos
    const compressedFile = new File([compressedBytes], pdfFile.name, {
      type: 'application/pdf',
      lastModified: new Date().getTime(),
    });
    
    const endTime = performance.now();
    const timeTaken = endTime - startTime;
    
    console.log(`PDF comprimido: ${pdfFile.name}`);
    console.log(`Tamaño original: ${pdfFile.size / 1024 / 1024} MB`);
    console.log(`Tamaño comprimido: ${compressedFile.size / 1024 / 1024} MB`);
    console.log(`Reducción: ${Math.round(100 - (compressedFile.size / pdfFile.size * 100))}%`);
    console.log(`Tiempo de compresión: ${Math.round(timeTaken)}ms`);
    
    return compressedFile;
  } catch (error) {
    console.error('Error al comprimir PDF:', error);
    console.log('Utilizando archivo original sin comprimir');
    return pdfFile; // Si falla la compresión, devuelve el archivo original
  }
}

/**
 * Determina si el archivo necesita compresión basado en su tamaño
 * @param {File} file - Archivo a evaluar
 * @param {number} thresholdMB - Tamaño umbral en MB
 * @returns {boolean} - true si necesita compresión
 */
export function needsCompression(file, thresholdMB = 2) {
  const fileSizeMB = file.size / (1024 * 1024);
  return fileSizeMB > thresholdMB;
}
